var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdmissionsde(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4433_5944)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M7.5 15H12.3917L10.8333 13.4417L9.91667 13.6917C8.24167 14.1583 7.56667 14.8 7.5 15ZM14.1667 6.66667C14.1667 5.75 13.4167 5 12.5 5C11.675 5 10.9917 5.6 10.8583 6.39167L12.7833 8.31667C13.5583 8.18333 14.1667 7.49167 14.1667 6.66667Z",
    fill: "black",
    fillOpacity: 0.54
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0667 9.95832C12.2083 9.97499 12.35 9.99999 12.5 9.99999C14.3417 9.99999 15.8333 8.50832 15.8333 6.66665C15.8333 4.82499 14.3417 3.33332 12.5 3.33332C10.6583 3.33332 9.16667 4.82499 9.16667 6.66665C9.16667 6.81665 9.19167 6.95832 9.20833 7.09999L12.0667 9.95832ZM12.5 4.99999C13.4167 4.99999 14.1667 5.74999 14.1667 6.66665C14.1667 7.49165 13.5583 8.18332 12.775 8.30832L10.85 6.38332C10.9917 5.59999 11.675 4.99999 12.5 4.99999ZM13.9083 11.8L18.775 16.6667H19.1667V15C19.1667 13.2167 16.2 12.0833 13.9083 11.8ZM0 2.59999L3.33333 5.93332V8.33332H0.833333V9.99999H3.33333V12.5H5V9.99999H7.4L9.49167 12.0917C7.65833 12.5917 5.83333 13.5833 5.83333 15V16.6667H14.0667L17.4 20L18.575 18.825L1.175 1.42499L0 2.59999ZM10.8417 13.4417L12.4 15H7.5C7.56667 14.8 8.23333 14.1583 9.925 13.6917L10.8417 13.4417ZM5 7.59999L5.73333 8.33332H5V7.59999Z",
    fill: "black",
    fillOpacity: 0.54
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4433_5944"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdmissionsde);
export default __webpack_public_path__ + "static/media/admissionsde.aed2a59689e4ce17787b8c6f7df92f52.svg";
export { ForwardRef as ReactComponent };